import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import WizardBodyTemplate from 'app/shared/components/WizardBodyTemplate';
import WizardActionFooter from 'app/shared/components/WizardActionFooter';
import InfoList from 'app/shared/components/InfoList';

const propTypes = {
    onGoToPrevStep: PropTypes.func.isRequired,
    onGoToNextStep: PropTypes.func.isRequired,
};
const defaultProps = {};

const Confirmation = ({
    onGoToNextStep,
    onGoToPrevStep,
}) => {
    const monthlyRent = useSelector(state => state.rentGuarantee.monthlyRent);
    const rentGuaranteeFee = useSelector(state => state.rentGuarantee.rentGuaranteeFee);
    const monthlyRentAddFee = useSelector(state => state.rentGuarantee.monthlyRentAddFee);

    const infos = [
        `The listing for this property will show the rent as ${Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumSignificantDigits: 5,
        }).format(monthlyRentAddFee)}.`,
        `The tenant’s monthly rent payment through Zillow will be ${Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumSignificantDigits: 5,
        }).format(monthlyRentAddFee)}, with the ${Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumSignificantDigits: 5,
        }).format(rentGuaranteeFee)} Rent Guarantee fee included. The fee will automatically be deducted after the
         tenant pays, and ${Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumSignificantDigits: 5,
    }).format(monthlyRent)} will be deposited in your bank account.`,
        'Set up online applications and lease signing.',
    ];

    return (
        <WizardBodyTemplate
            title="Confirm your selections"
            subtitle="Here’s your Rent Guarantee setup summary. It will be fully activated when the tenant makes their
            first monthly rent payment."
        >
            <InfoList infos={infos} />
            <WizardActionFooter
                nextLabel="Confirm"
                onBackClick={onGoToPrevStep}
                onNextClick={onGoToNextStep}
            />
        </WizardBodyTemplate>
    );
};

Confirmation.propTypes = propTypes;
Confirmation.defaultProps = defaultProps;

export default Confirmation;
